<template>
  <div class="historyPolicy-container">
    <el-row
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
    >
      <el-row>
        <el-col :span="8">
          <el-col :span="8">保险公司：</el-col>
          <el-col :span="16">{{ $judgeEmpty(historyForm.companyName) }}</el-col>
        </el-col>
        <!-- <el-col :span="4"></el-col> -->
        <el-col :span="8">
          <el-col :span="10">交强险生效日期：</el-col>
          <el-col :span="14">{{
            $judgeEmpty(historyForm.effectiveDate)
          }}</el-col>
        </el-col>
        <el-col :span="8">
          <el-col :span="10">商业险生效日期：</el-col>
          <el-col :span="14">{{
            $judgeEmpty(historyForm.businessDate)
          }}</el-col>
        </el-col>
      </el-row>
      <el-row class="watch-item">
        <el-row class="item-top">
          <el-col :span="4">
            <p class="dialog-title">交强险保单</p>
          </el-col>
          <el-col :span="16">
            <el-button
              type="primary"
              @click="exportData(historyForm.compulsoryInsurance, true)"
              >导出</el-button
            >
          </el-col>
        </el-row>
        <el-row class="item-bottom">
          <div
            class="imgWrap"
            v-if="historyForm.compulsoryInsurance"
            @click="previewTrafficPdf"
          >
            <vue-pdf-embed :source="historyForm.compulsoryInsurance" />
            <!-- <pdf :src="trafficPolicySrc"></pdf> -->
            <el-dialog
              :visible.sync="iframeTrafficVisible"
              append-to-body
              title="预览/下载 pdf"
            >
              <iframe
                :src="historyForm.compulsoryInsurance"
                frameborder="0"
                style="width: 100%; height: 600px"
              ></iframe>
            </el-dialog>
          </div>
        </el-row>
      </el-row>
      <el-row class="watch-item">
        <el-row class="item-top">
          <el-col :span="4">
            <p class="dialog-title">商业险保单</p>
          </el-col>
          <el-col :span="16">
            <el-button
              type="primary"
              @click="exportData(historyForm.commercialInsurance, true)"
              >导出</el-button
            >
          </el-col>
        </el-row>
        <el-row class="item-bottom">
          <div
            class="imgWrap"
            v-if="historyForm.commercialInsurance"
            @click="previewCommercialPdf"
          >
            <vue-pdf-embed :source="historyForm.commercialInsurance" />
            <!-- <pdf :src="commercialPolicySrc"></pdf> -->
            <el-dialog
              :visible.sync="iframeCommercialVisible"
              append-to-body
              title="预览/下载 pdf"
            >
              <iframe
                :src="historyForm.commercialInsurance"
                frameborder="0"
                style="width: 100%; height: 600px"
              ></iframe>
            </el-dialog>
          </div>
        </el-row>
      </el-row>
      <el-row class="watch-item">
        <el-row class="item-top">
          <el-col :span="4">
            <p class="dialog-title">保险发票</p>
          </el-col>
          <el-col :span="16">
            <el-button
              v-if="historyForm.invoicePdf"
              type="primary"
              @click="exportData(historyForm.invoicePdf, true)"
              >导出PDF</el-button
            >
            <el-button
              v-if="historyForm.invoicePhoto"
              type="primary"
              @click="exportData(historyForm.invoicePhoto, false)"
              >导出图片</el-button
            >
          </el-col>
        </el-row>
        <el-row class="item-bottom">
          <el-image
            :src="historyForm.invoicePhoto1"
            :preview-src-list="[historyForm.invoicePhoto1]"
          >
            <div slot="error">未上传</div>
          </el-image>
          <el-image
            :src="historyForm.invoicePhoto2"
            :preview-src-list="[historyForm.invoicePhoto2]"
          >
            <div slot="error">未上传</div>
          </el-image>
          <div
            class="imgWrap"
            @click="previewBillPdf(1)"
            v-if="historyForm.invoicePdf1"
          >
            <vue-pdf-embed :source="historyForm.invoicePdf1" />
            <!-- <pdf :src="billPolicySrc"></pdf> -->
            <el-dialog
              :visible.sync="iframeBillVisible1"
              append-to-body
              title="预览/下载 pdf"
            >
              <iframe
                :src="historyForm.invoicePdf1"
                frameborder="0"
                style="width: 100%; height: 800px"
              ></iframe>
            </el-dialog>
          </div>
          <div v-else class="el-image">未上传</div>
          <div
            class="imgWrap"
            @click="previewBillPdf(2)"
            v-if="historyForm.invoicePdf2"
          >
            <vue-pdf-embed :source="historyForm.invoicePdf2" />
            <!-- <pdf :src="billPolicySrc"></pdf> -->
            <el-dialog
              :visible.sync="iframeBillVisible2"
              append-to-body
              title="预览/下载 pdf"
            >
              <iframe
                :src="historyForm.invoicePdf2"
                frameborder="0"
                style="width: 100%; height: 800px"
              ></iframe>
            </el-dialog>
          </div>
          <div v-else class="el-image">未上传</div>
        </el-row>
      </el-row>
    </el-row>
  </div>
</template>

<script>
import VuePdfEmbed from "vue-pdf-embed/dist/vue2-pdf-embed";
// import pdf from "vue-pdf-signature";
// import CMapReaderFactory from "vue-pdf-signature/src/CMapReaderFactory.js";
export default {
  name: "HistoryPolicy",
  props: ["historyFormId"],
  components: {
    VuePdfEmbed,
  },
  // computed: {
  //   //解决预览pdf文字丢失Warning: Error during font loading: The CMap “baseUrl“ parameter must be specifie的问题
  //   trafficPolicySrc() {
  //     //处理pdfUrl返回
  //     let src = pdf.createLoadingTask({
  //       url: this.historyForm.compulsoryInsurance,
  //       CMapReaderFactory,
  //     });
  //     return src;
  //   },
  //   commercialPolicySrc() {
  //     let src = pdf.createLoadingTask({
  //       url: this.historyForm.commercialInsurance,
  //       CMapReaderFactory,
  //     });
  //     return src;
  //   },
  //   billPolicySrc() {
  //     //处理pdfUrl返回
  //     let src = pdf.createLoadingTask({
  //       url: this.historyForm.invoicePdf,
  //       CMapReaderFactory,
  //     });
  //     return src;
  //   },
  // },
  data() {
    return {
      historyForm: {},
      iframeCommercialVisible: false,
      iframeTrafficVisible: false,
      iframeBillVisible1: false,
      iframeBillVisible2: false,
      loading: false,
    };
  },
  mounted() {
    this.loading = true;
    console.log(this.historyFormId);
    this.getHistoryItem(this.historyFormId);
  },
  methods: {
    async getHistoryItem(id) {
      this.historyForm = {};
      let { data: res } = await this.$axios.get(
        "/api/vehicle/insuranceManage/selectGetOne",
        {
          params: { id: id },
        }
      );
      if (res.code == 1) {
        this.historyForm = {
          ...res.data,
          invoicePdf1: res.data.invoicePdf && res.data.invoicePdf.split(",")[0],
          invoicePdf2: res.data.invoicePdf && res.data.invoicePdf.split(",")[1],
          invoicePhoto1:
            res.data.invoicePhoto && res.data.invoicePhoto.split(",")[0],
          invoicePhoto2:
            res.data.invoicePhoto && res.data.invoicePhoto.split(",")[1],
        };
        // // 处理返回的数据.截取头部地址
        // let strPdf = "";
        // let strPhoto = "";
        // if (res.data.invoicePdf) {
        //   strPdf =
        //     this.getProtocolAndHost(res.data.invoicePdf.split(",")[0]) +
        //     "/vehicleinsurance";
        // }
        // if (res.data.invoicePhoto) {
        //   strPhoto =
        //     this.getProtocolAndHost(res.data.invoicePhoto.split(",")[0]) +
        //     "/vehicleinsurance";
        // }
        // this.historyForm.invoicePdf1 =
        //   strPdf && res.data.invoicePdf.split(",")[0];
        // if (res.data.invoicePdf && res.data.invoicePdf.split(",")[1]) {
        //   this.historyForm.invoicePdf2 =
        //     strPdf +
        //     res.data.invoicePdf
        //       .split(",")[1]
        //       .substring(res.data.invoicePdf.split(",")[1].lastIndexOf("/"));
        // } else {
        //   this.historyForm.invoicePdf2 = "";
        // }
        // this.historyForm.invoicePhoto1 =
        //   strPhoto && res.data.invoicePhoto.split(",")[0];
        // if (res.data.invoicePhoto && res.data.invoicePhoto.split(",")[1]) {
        //   this.historyForm.invoicePhoto2 =
        //     strPhoto +
        //     res.data.invoicePhoto
        //       .split(",")[1]
        //       .substring(res.data.invoicePhoto.split(",")[1].lastIndexOf("/"));
        // } else {
        //   this.historyForm.invoicePhoto2 = "";
        // }
        this.loading = false;
      } else {
        this.$message.warning(res.msg);
      }
    },
    subString(str) {
      return str.substring(str.lastIndexOf("/") + 1);
    },
    // getProtocolAndHost(url) {
    //   let result = url.match(/^([a-zA-Z]+:\/\/)([^\/]+)/);
    //   return result ? result[0] : null;
    // },
    //数据导出
    exportData(url, type) {
      let _this = this;
      _this
        .$confirm("确定导出当前数据吗？", "系统提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "success",
        })
        .then(async () => {
          url.split(",").forEach((urlSingle) => {
            let name = _this.subString(urlSingle);
            if (type) {
              this.downloadFile(urlSingle, name);
            } else {
              this.downloadImg(urlSingle, name);
            }
          });
        });
    },
    downloadFile(url, fileName) {
      fetch(url)
        .then((response) => response.blob())
        .then((blob) => {
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = fileName;
          link.target = "_blank"; // 可选，如果希望在新窗口中下载文件，请取消注释此行
          link.click();
        });
    },
    downloadImg(src, name) {
      let image = new Image();
      image.src = src;
      image.setAttribute("crossOrigin", "anonymous");
      image.onload = function() {
        let c = document.createElement("canvas");
        c.width = image.width;
        c.height = image.height;
        c.getContext("2d").drawImage(image, 0, 0, image.width, image.height);
        let a = document.createElement("a");
        a.download = name;
        a.href = c.toDataURL("image/jpg");
        a.click();
      };
    },
    previewTrafficPdf() {
      this.iframeTrafficVisible = true;
    },
    previewCommercialPdf() {
      this.iframeCommercialVisible = true;
    },
    previewBillPdf(type) {
      if (type === 2) {
        this.iframeBillVisible2 = true;
      } else {
        this.iframeBillVisible1 = true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.dialog-title {
  width: 100%;
  height: 20px;
  padding-left: 10px;
  margin-bottom: 10px;
  border-left: 4px solid #0093ff;
  font-size: 14px;
  font-weight: bold;
  color: #333;
  box-sizing: border-box;
}
.watch-item {
  margin-top: 20px !important;
  .item-top {
    display: flex;
    flex-direction: column;
  }
  .item-bottom {
    padding-top: 20px !important;
    max-width: 750px;
  }
}
.imgWrap {
  position: relative;
  margin-top: 20px;
  max-width: 750px;
  max-height: 340px;
  overflow-y: auto;
  overflow-x: hidden;
}
.imgWrap img {
  // width: auto;
  max-width: 750px;
  height: 280px;
}
/deep/ .el-image {
  display: block;
  margin-right: 20px;
}
</style>
